<template>
    <div class="basicForm basicForm--constructionType">
        <div class="basicForm__row basicForm__item basicForm__item--area">
            <label for="area" class="basicForm__label">Plocha</label>
            <input id="area"
                   class="basicForm__input basicForm__input--calculator-area basicForm__input--withDescription"
                   type="number" size="5" v-model="meters">
            <div class="basicfForm__inputDescription">
                m<sup>2</sup>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="basicForm__row basicForm__item basicForm__item--trash">
            <label for="trash" class="basicForm__label">Odpad</label>
            <input id="trash"
                   class="basicForm__input basicForm__input--calculator-trash basicForm__input--withDescription"
                   type="number" size="2" :value="userInputCut" @input="update">
            <div class="basicfForm__inputDescription basicfForm__inputDescription--percent">%</div>
            <div class="basicfForm__inputDescription basicfForm__inputDescription--small">
                Množství odpadu záleží na velikosti a&nbsp;složitosti prostoru a také vaší šikovnosti. U konstrukcí to
                většinou bývá od&nbsp;5 do 10 %.
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';

export default {
    name:     'CalculationUserInput',
    watch:    {
        cut: function (newValue) {
            console.log(newValue);
        }
    },
    computed: {
        ...mapGetters('calculation', ['userInputCut']),
        ...mapFields('calculation', [
            'userInput.meters',
            'userInput.cut'
        ]),
    },
    methods: {
        ...mapActions('calculation', ['setUserInputCut']),
        update(e) {
            const value = e.target.value;
            this.setUserInputCut(value);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/calculation/calculator/user-input/UserInput.vue